import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Modal extends Component
{

	static propTypes = {
		identifier: PropTypes.string.isRequired,
		callBack: PropTypes.func.isRequired,

		title: PropTypes.string,
		text: PropTypes.string,
		dismissText: PropTypes.string,
		actionText: PropTypes.string.isRequired
	};

	render () {
		return (
			<div className="modal fade" id={this.props.identifier} tabIndex="-1" role="dialog" aria-labelledby="ModalLabel" style={{display: 'none'}}>
				<div className="modal-dialog">
					<div className="modal-content">
						<div className="modal-header justify-content-center">
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<i className="nc-icon nc-simple-remove"/>
							</button>
							{this.props.title ? <h4 className="title title-up">{this.props.title}</h4> : null}
						</div>
						{this.props.text ? (
							<div className="modal-body">
								<p>{this.props.text}</p>
							</div>
						) : null}
						<div className="modal-footer">
							{this.props.dismissText ? (
								<div className="left-side">
									<button type="button" className="btn btn-default btn-link" data-dismiss="modal">
										{this.props.dismissText}
									</button>
								</div>
							) : null}
							<div className="divider"/>
							<div className="right-side">
								<a onClick={this.props.callBack} className="btn btn-danger btn-link" data-dismiss="modal">{this.props.actionText}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./React/src/components/general/Modal.js